import React from 'react';
import Modal from './modal';
import Button from '../button/button';
import styles from './index.scss';

const ExitClassModal = ({ title, type = 'student', onSubmit, onClose }) => {
    return (
        <Modal onClose={onClose} title={title}>
            <div className={styles.exitClassBox}>
                <div className={styles.exitContent}>{type === 'student' ? '确认要退出当前班级吗？' : '确认要解散当前班级吗？'}</div>
                <div className={styles.exitBtn}>
                    <Button
                        label={'取消'}
                        onClick={onClose}
                    />
                    <Button
                        theme={'submit'}
                        label={'确认'}
                        onClick={onSubmit}
                    />
                </div>
            </div>
        </Modal>
    )
}

export default ExitClassModal